export const gridBreakpoints = {
  xs: 0,
  sm: 540,
  md: 740,
  lg: 1020,
  xl: 1440,
};

export const gridGutterWidth = 20;

export const deviceIsMinLarge = window.matchMedia(
  `only screen and (min-width: ${gridBreakpoints.lg}px)`);

export const deviceIsMinMd = window.matchMedia(
  `only screen and (min-width: ${gridBreakpoints.md}px)`);

export const deviceIsMinSm = window.matchMedia(
  `only screen and (min-width: ${gridBreakpoints.sm}px)`);

export const deviceIsXs = window.matchMedia(
  `only screen and (max-width: ${gridBreakpoints.sm}px)`);
